import _asyncToGenerator from "E:/meari/cloudMall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-734283df"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "right"
};
var _hoisted_2 = {
  class: "toBuy"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 去购买 ");

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "loginTitle"
  }, "欢迎登录", -1);
});

var _hoisted_5 = {
  class: "sumbitBox"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 登录 ");

var _hoisted_7 = {
  class: "userAmount"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("登出");

import { onMounted, ref, watch } from "vue";
import { showSuccessToast, showFailToast } from "vant";
import { singInApi, signOutApi } from "@/api";
import { useRouter } from "vue-router";
import GlobalStateService from "@/services/global";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var isScroll = ref(false);
    var isLogin = ref(false);
    var userInfoShow = ref(false);
    var toBuyVisible = ref(false);
    var loginForm = ref({
      username: "",
      password: ""
    });
    var userAccount = ref("");

    var loginHandle = function loginHandle() {
      if (!isLogin.value) {
        GlobalStateService.state.showLogin = true;
      } else {
        userInfoShow.value = true;
      }
    };

    var onSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginBody, loginRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("sumbit");
                loginBody = {
                  userAccount: loginForm.value.username,
                  password: loginForm.value.password,
                  phoneCode: "86",
                  countryCode: "CN",
                  lngType: "en"
                };
                _context.next = 4;
                return singInApi(loginBody);

              case 4:
                loginRes = _context.sent;

                if (loginRes) {
                  console.log(loginRes);
                  GlobalStateService.state.userId = loginRes.userID;
                  GlobalStateService.state.userToken = loginRes.userToken;
                  userAccount.value = loginRes.userAccount;
                  sessionStorage.setItem("userInfo", JSON.stringify(loginRes));
                  showSuccessToast("登录成功");
                  isLogin.value = true;
                  GlobalStateService.state.showLogin = false;
                } else {
                  showFailToast("登录失败");
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function onSubmit() {
        return _ref.apply(this, arguments);
      };
    }();

    var loginDialogCancel = function loginDialogCancel() {
      GlobalStateService.state.showLogin = false;
    };

    var logout = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return signOutApi();

              case 2:
                result = _context2.sent;

                if (result) {
                  showSuccessToast("登出成功");
                  userInfoShow.value = false;
                  isLogin.value = false;
                  router.push("/");
                } else {
                  showFailToast("登出失败");
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function logout() {
        return _ref2.apply(this, arguments);
      };
    }();

    var toPay = function toPay() {
      if (!isLogin.value) {
        GlobalStateService.state.showLogin = true;
        return;
      }

      router.push("productDetail");
    };

    var back = function back() {
      router.push("/");
    };

    watch(function () {
      return router.currentRoute.value.path;
    }, function (path) {
      if (path === "/productDetail") {
        toBuyVisible.value = false;
      } else {
        toBuyVisible.value = true;
      }
    }, {
      immediate: true
    });
    onMounted(function () {
      var storageUserInfo = sessionStorage.getItem("userInfo");

      if (storageUserInfo) {
        var userInfo = JSON.parse(storageUserInfo);
        GlobalStateService.state.userId = userInfo.userID;
        GlobalStateService.state.userToken = userInfo.userToken;
        userAccount.value = userInfo.userAccount;
        isLogin.value = true;
      }

      window.addEventListener("scroll", function () {
        if (window.scrollY !== 0) {
          isScroll.value = true;
        } else {
          isScroll.value = false;
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_van_icon = _resolveComponent("van-icon");

      var _component_van_button = _resolveComponent("van-button");

      var _component_van_field = _resolveComponent("van-field");

      var _component_van_cell_group = _resolveComponent("van-cell-group");

      var _component_van_form = _resolveComponent("van-form");

      var _component_van_dialog = _resolveComponent("van-dialog");

      var _component_van_popup = _resolveComponent("van-popup");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass("pageHeader ".concat(isScroll.value ? 'scroll' : ''))
      }, [_createElementVNode("div", {
        class: "left"
      }, [_createElementVNode("div", {
        class: "logo",
        onClick: back
      })]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "loginIcon",
        onClick: loginHandle
      }, [_createVNode(_component_van_icon, {
        name: "user-circle-o",
        size: "0.6rem"
      })]), _withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
        type: "primary",
        size: "mini",
        color: "#14beb4",
        onClick: toPay
      }, {
        default: _withCtx(function () {
          return [_hoisted_3];
        }),
        _: 1
      })], 512), [[_vShow, toBuyVisible.value]])]), _createVNode(_component_van_dialog, {
        show: _unref(GlobalStateService).state.showLogin,
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return _unref(GlobalStateService).state.showLogin = $event;
        }),
        showConfirmButton: false,
        showCancelButton: false,
        closeOnClickOverlay: true,
        onClose: loginDialogCancel
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_form, {
            class: "loginForm",
            onSubmit: onSubmit
          }, {
            default: _withCtx(function () {
              return [_hoisted_4, _createVNode(_component_van_cell_group, {
                inset: ""
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_field, {
                    modelValue: loginForm.value.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return loginForm.value.username = $event;
                    }),
                    name: "用户名",
                    label: "用户名",
                    placeholder: "用户名",
                    rules: [{
                      required: true,
                      message: '请填写用户名'
                    }]
                  }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                    modelValue: loginForm.value.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return loginForm.value.password = $event;
                    }),
                    type: "password",
                    name: "密码",
                    label: "密码",
                    placeholder: "密码",
                    rules: [{
                      required: true,
                      message: '请填写密码'
                    }]
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit",
                color: "#14beb4"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_6];
                }),
                _: 1
              })])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: userInfoShow.value,
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return userInfoShow.value = $event;
        }),
        teleport: "body",
        position: "bottom",
        round: "",
        style: {
          height: '20%'
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, _toDisplayString(userAccount.value), 1), _createVNode(_component_van_button, {
            type: "primary",
            block: "",
            color: "#14beb4",
            onClick: logout
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["show"])], 2);
    };
  }
});